import { RouterProvider } from "react-router-dom";
import AuthRoutes from "./routes/router";
import { SpinnerProvider } from "./components/spinner/SpinnerContext";
import Spinner from "./components/spinner/Spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AppBanner from "./components/AppBanner";
// import { PostHogProvider } from "posthog-js/react";

const isPostHogEnabled = process.env.REACT_APP_ENABLE_ANALYTICS === "true";

const PostHogWrapper = isPostHogEnabled
  ? require("posthog-js/react").PostHogProvider
  : ({ children }: { children: React.ReactNode }) => <>{children}</>;
const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "",
};

function App() {
  const handleChunkError = (error: any) => {
    console.log(
      "here the App.tsx , checking the ChunkLoadError, ChunkLoadError to reload the page here checking"
    );
    if (
      error?.name === "ChunkLoadError" ||
      (error?.message || "").includes("ChunkLoadError")
    ) {
      console.log("Reloaded");
      window.location.reload();
    }
  };

  window.addEventListener("unhandledrejection", (event) => {
    handleChunkError(event.reason);
  });

  window.addEventListener("error", (event) => {
    handleChunkError(event.error);
  });

  return (
    <PostHogWrapper
      {...(isPostHogEnabled && {
        apiKey: process.env.REACT_APP_PUBLIC_POSTHOG_KEY || "",
        options,
      })}
    >
      <SpinnerProvider>
        {/* <AppBanner /> */}
        <RouterProvider router={AuthRoutes} future={{ v7_startTransition: true }}/>
        <Spinner />
        <ToastContainer />
      </SpinnerProvider>
    </PostHogWrapper>
  );
}

export default App;
